import React, { useContext, useEffect, useState } from "react";
import { CCard, CCardBody, CCardHeader, CCol, CRow } from "@coreui/react";
import CustomWidgetProgress from "./CustomWidgetProgress";
import Auth from "src/auth";
import { apiCallSPGet } from "src/_apiConfig/apiCall";
import MenuContext from "src/_components/ContextAPI";
import { Height, VerticalAlignTop } from "@mui/icons-material";

const HONotification = () => {
  const { authenticated } = Auth();
  const [userData, setUserData] = useState([]);
  const { cgmfRouteListData } = useContext(MenuContext);

  useEffect(() => {
    getNotificatinHOList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  const getNotificatinHOList = async () => {
    if (authenticated) {
      setUserData([]);

      await apiCallSPGet(`Notification/HO?userId=${authenticated.userId}`).then(
        (res) => {
          if (res.success) setUserData(res.data);
        }
      );
    }
  };
  const data = [
    {
      color: "success",
      header: userData?.hoBankGuaranteePayment,
      text: "Bank Guarantee Payment",
      onClick: "/requestlist/bankguaranteelist",
      footer: "",
      accesskey: "requestlist_bankguaranteelist",
    },
    {
      color: "info",
      header: userData?.hoTransferLotApproval,
      text: "Lot Transfer Approval",
      onClick: "/requestlist/transfertoholotapprovals",
      footer: "",
      accesskey: "requestlist_transfertoholotapprovals",
    },
    {
      color: "warning",
      header: userData?.hoIncomeTaxConcession,
      text: "Income Tax Concession",
      onClick: "/requestlist/incometaxconsessionrequest",
      footer: "",
      accesskey: "requestlist_incometaxconsessionrequest",
    },
    {
      color: "danger",
      header: userData?.hoPendingAgreementExtend,
      text: "Pending Agreement Extend ",
      onClick: "/requestlist/PendingAgreementextendListHO",
      footer: "",
      accesskey: "requestlist_PendingAgreementextendListHO",
    },
    {
      color: "primary",
      header: userData?.hoPendingUsersApproval,
      text: "Pending Users Approval",
      onClick: "/requestlist/pendingapprovals",
      footer: "",
      accesskey: "requestlist_pendingapprovals",
    },

    {
      color: "secondary",
      header: userData?.hoLotLeftRequest,
      text: "Lot Left",
      onClick: "requestlist/leftlotrequestlistho",
      footer: "",
      accesskey: "requestlist_lotleftrequestlistho",
    },
    {
      color: "dark",
      header: userData?.hoAdHocPaymentApprovalPending,
      text: "Adjustment Payment - Pending",
      onClick: "lot/adhocpayment/type/1",
      footer: "",
      accesskey: "lot_adhocpayment",
    },
    {
      color: "success",
      header: userData?.hoAdHocPaymentClarificationMe,
      text: "Adjustment Payment - Clarification ",
      onClick: "lot/adhocpayment/type/4",
      footer: "",
      accesskey: "lot_adhocpayment",
    },
  ];

  const dataLotDetails = [
    // {
    //   color: "dark",
    //   header: userData?.hoLotTransfer,
    //   text: "Lot - Transfer ",
    //   onClick: "",
    //   footer: "",
    // },
  ];

  const isAllow = (accesskey) => {
    return cgmfRouteListData?.some(
      (existingItem) => existingItem.accessKey === accesskey
    );
  };
  return (
    <CRow>
      <CCol xs="12">
        <CCard class="dashboard HO">
          <CCardHeader>
          {/* <CRow>
              <CCol>
                <div >
             <br></br>
             <marquee style={{ color: 'red', fontWeight: 'bold', fontSize: '18px', Height:'50px' }}>Important Note: Our website will undergo scheduled maintenance and will be unavailable for approximately 30 hours starting from 10th October 2025 at 11:59 PM onwards.</marquee>
          </div> 
              </CCol>
            </CRow> */}
            <CRow>
              <CCol xs={10}>
                <h3>Notification</h3>
              </CCol>
              <CCol xs={2} style={{ textAlign: "right" }}>
                <a
                  className="ml-2"
                  target="_blank"
                  href={`http://202.131.108.246:4019/scp/login.php`}
                  rel="noreferrer"
                >
                  <b>Support Ticket</b>
                </a>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow className="pt-3 ">
              {data.map(
                (item, index) =>
                  isAllow(item.accesskey) && (
                    <CustomWidgetProgress item={item} index={index} />
                  )
              )}
            </CRow>
            <CRow className="pt-3 ">
              {dataLotDetails.map((item, index) => (
                <CustomWidgetProgress item={item} index={index} />
              ))}
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default HONotification;
